import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { Glossary } from "src/components/Text/Glossary";
import { TextWithOverflowTooltip } from "src/components/TextWithOverflowTooltip";
import type { GlossaryFn } from "src/types/glossary";
import { ColumnId } from "./constants";

type SchoolColumnDefConfig = {
  glossary: GlossaryFn;
};

type Row = {
  school: { name: string } | null;
};
export function buildSchoolColumnDef<T extends Row>({
  glossary,
}: SchoolColumnDefConfig): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.school?.name,
    id: ColumnId.School,
    header: glossary`Apl. School`,
    tooltip: glossary`Sort by school name`,
    cell: (props) => {
      const school = props.row.original.school;
      if (school) {
        return (
          <TextWithOverflowTooltip
            minWidth="160px"
            maxWidth="260px"
            content={school.name}
          />
        );
      }

      return (
        <Text minWidth="160px" variant="placeholder">
          <Glossary>No school</Glossary>
        </Text>
      );
    },
  };
}
